// Module
var code = "<div layout=\"column\" class=\"full-height\"> <sms-messages-table flex infinite-scroll=\"$ctrl.infiniteScroll\" is-scrollable=\"$ctrl.isScrollable\"> </sms-messages-table> </div> ";
// Exports
export default code;